import { render, staticRenderFns } from "./customizeFieldView.vue?vue&type=template&id=6c543ac3&"
import script from "./customizeFieldView.vue?vue&type=script&lang=js&"
export * from "./customizeFieldView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports